import { useCurrencyFormatter } from '@ramp106/omrjs-core-ui'
import { formatDate } from 'date-fns'
import { de, enUS } from 'date-fns/locale'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { ProductData } from '@/gql/reviews'

export const NAME_MIN_LENGTH = 3
export const NAME_MAX_LENGTH = 40

export function useReviewsCampaignFormOptions(product: ProductData) {
  const { t, locale } = useI18n()
  const { formatCurrency } = useCurrencyFormatter()

  const getDateFnsLocale = () => {
    return locale.value === 'de' ? de : enUS
  }

  const today = formatDate(new Date(), 'yyyy-MM-dd')

  const maxValidToDate = computed(() =>
    product.currentBudget?.endDate ? formatDate(product.currentBudget.endDate, 'yyyy-MM-dd') : undefined,
  )

  const budgetEndDate = computed(() =>
    product.currentBudget?.endDate ? formatDate(product.currentBudget.endDate, 'dd.MM.yyyy') : undefined,
  )

  const budgetEndDateLong = computed(() =>
    product.currentBudget?.endDate ? formatDate(product.currentBudget.endDate, 'd MMMM yyyy', { locale: getDateFnsLocale() }) : undefined,
  )

  const amazonAmountOptions = computed(() => {
    const options: { label: string; value: number }[] = []
    ;[10, 15, 20, 25, 30, 40, 50, 75, 100].forEach((value) => {
      const label =
        value === 25 ? t('Reviews.product.campaign.form.amount.input.recommended', { value: formatCurrency(value) }) : formatCurrency(value)
      options.push({ label, value })
    })
    return options
  })

  const wunschFormattedValue = computed(() => formatCurrency(20))

  const amazonFormattedValue = computed(() => {
    const minValue = Math.min(...amazonAmountOptions.value.map((option) => option.value))
    const maxValue = Math.max(...amazonAmountOptions.value.map((option) => option.value))
    return `${formatCurrency(minValue)} – ${formatCurrency(maxValue)}`
  })

  return {
    today,
    maxValidToDate,
    budgetEndDate,
    budgetEndDateLong,
    amazonAmountOptions,
    wunschFormattedValue,
    amazonFormattedValue,
  }
}
